import { gql } from '@apollo/client';

export const LOGIN_MUTATION = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      token
      user {
        _id
        email
        firstName
        lastName
        username
        aiConsent
        consentVersion
      }
    }
  }
`;

export const SIGNUP_MUTATION = gql`
  mutation Signup(
    $email: String!
    $password: String!
    $termsAccepted: Boolean
    $confirmedAdult: Boolean
    $aiConsent: Boolean
    $consentVersion: String
    $marketingOptIn: Boolean
  ) {
    signup(
      email: $email
      password: $password
      termsAccepted: $termsAccepted
      confirmedAdult: $confirmedAdult
      aiConsent: $aiConsent
      consentVersion: $consentVersion
      marketingOptIn: $marketingOptIn
    ) {
      token
      user {
        _id
        firstName
        lastName
        username
        email
        aiConsent
        consentVersion
        notificationPreferences {
          marketing
        }
      }
    }
  }
`;

export const GOOGLE_AUTH_MUTATION = gql`
  mutation GoogleAuth(
    $credential: String!
    $termsAccepted: Boolean
    $confirmedAdult: Boolean
    $aiConsent: Boolean
    $consentVersion: String
    $marketingOptIn: Boolean
  ) {
    googleAuth(
      credential: $credential
      termsAccepted: $termsAccepted
      confirmedAdult: $confirmedAdult
      aiConsent: $aiConsent
      consentVersion: $consentVersion
      marketingOptIn: $marketingOptIn
    ) {
      token
      user {
        _id
        email
        firstName
        lastName
        username
        aiConsent
        consentVersion
      }
    }
  }
`;

export const UPDATE_PROFILE = gql`
  mutation UpdateProfile($firstName: String, $lastName: String, $username: String) {
    updateProfile(firstName: $firstName, lastName: $lastName, username: $username) {
      token
      user {
        _id
        firstName
        lastName
        username
        email
      }
    }
  }
`;

export const RECORD_AI_CONSENT = gql`
  mutation RecordAiConsent($aiConsent: Boolean!, $consentVersion: String) {
    recordAiConsent(aiConsent: $aiConsent, consentVersion: $consentVersion) {
      _id
      aiConsent
      consentVersion
    }
  }
`;

export const REQUEST_PASSWORD_RESET = gql`
  mutation requestPasswordReset($email: String!) {
    requestPasswordReset(email: $email)
  }
`;

export const RESET_PASSWORD = gql`
  mutation resetPassword($token: String!, $password: String!) {
    resetPassword(token: $token, password: $password) {
      token
      user {
        _id
        email
      }
    }
  }
`;

export const DELETE_USER_MUTATION = gql`
  mutation deleteUser {
    deleteUser
  }
`;

export const UPDATE_NOTIFICATION_PREFERENCES = gql`
  mutation UpdateNotificationPreferences($input: NotificationPreferencesInput!) {
    updateNotificationPreferences(input: $input) {
      _id
      notificationPreferences {
        postExpiringWarning
        postExpiredNotice
        marketing
      }
    }
  }
`;
